//App.js is the main file of the project. It is the first file that is executed when the project is run.

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/main/Layout';
import LoginLayout from './components/login/LoginLayout';
import { AuthProvider } from './components/auth/AuthContext';
import ForgotPassword from './components/forgotpassword/ForgotPassword';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminCallerIdRequests from './components/admin/AdminCallerIdRequests';
import PrivateRoute from './routes/PrivateRoute';
import FileUploadTest from './tests/FileUploadTest';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SharedConversation from './components/chats/SharedConversation';
import TermsOfUse from './components/legal/TermsOfUse';
import PrivacyPolicy from './components/legal/PrivacyPolicy';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Auth routes */}
            <Route path="/login" element={<LoginLayout />} />
            <Route path="/register" element={<LoginLayout />} />
            <Route path="/forgot-password" element={<LoginLayout />} />

            {/* Public legal routes */}
            <Route path="/legal/terms" element={<TermsOfUse />} />
            <Route path="/legal/privacy" element={<PrivacyPolicy />} />

            {/* Protected routes */}
            <Route path="/admin" element={<PrivateRoute element={<AdminDashboard />} requireAdmin={true} />} />
            <Route path="/admin/caller-id-requests" element={<PrivateRoute element={<AdminCallerIdRequests />} requireAdmin={false} />} />
            <Route path="/test-uploads" element={<PrivateRoute element={<FileUploadTest />} requireAdmin={false} />} />
            
            {/* Shared conversation route */}
            <Route path="/chat/:conversationId" element={<SharedConversation />} />
            
            {/* Default layout route - should be last */}
            <Route path="/*" element={<Layout />} />
          </Routes>
        </div>
      </Router>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </AuthProvider>
  );
}

export default App;